<template>
    <button
        type="button"
        class="ds-icon-btn"
        :class="{ 'ds-icon-btn--active': active }"
        :aria-label="label"
        @click="$emit('click', $event)"
    >
        <ds-icon :name="icon" :size="size" :filled="filled" />
    </button>
</template>

<script>
export default {
    name: 'DsIconButton',
    props: {
        icon: { type: String, required: true },
        size: { type: [Number, String], default: 20 },
        label: { type: String, default: null },
        active: { type: Boolean, default: false },
        filled: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.ds-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: var(--radius-pill);
    border: none;
    cursor: pointer;
    transition: var(--transition-control);
    background: transparent;
    color: var(--text-muted);
    flex: 0 0 auto;
}
.ds-icon-btn:hover,
.ds-icon-btn--active {
    background: var(--surface-hover);
}
.ds-icon-btn--active {
    color: var(--brand-blue-deep);
}
</style>
